










import Vue from 'vue'
import PaperAirplane from './icons/PaperAirplane.vue'
import UserGroup from './icons/UserGroup.vue'
import ChevronDown from './icons/ChevronDown.vue'
import Reply from './icons/Reply.vue'
import DotsVertical from './icons/DotsVertical.vue'
import GlobeAlt from './icons/GlobeAlt.vue'
import LockClosed from './icons/LockClosed.vue'
import User from './icons/User.vue'

const icons = {
    paperairplane: PaperAirplane,
    usergroup: UserGroup,
    chevrondown: ChevronDown,
    reply: Reply,
    dotsvertical: DotsVertical,
    globealt: GlobeAlt,
    lockclosed: LockClosed,
    user: User
}
export default Vue.extend({
  name: 'BaseIcon',
  props: {
    hwClass: {
      type: String,
      default: 'h-5 w-5'
    },
    name: {
      type: String,
      required: true,
      validator(value) {
        return Object.prototype.hasOwnProperty.call(icons, value)
      }
    },
  },

  computed: {
    iconComponent() {
      return icons[this.name]
    },

    getHwClass() {
      return this.hwClass
    }
  }
})
